import React from "react";
import { getFilterOption } from "./filterOptions.jsx";

/**
 * Shared utility functions for displaying filters consistently across components
 * Extracted from ChipsContactFilter to avoid duplication
 */

export const getFilterIcon = (type) => {
  const option = getFilterOption(type);
  if (option && option.icon) {
    // Clone the icon and add inline styling
    return React.cloneElement(option.icon, {
      className: `${option.icon.props.className || ""} inline-block align-middle`,
    });
  }
  return "❓";
};

export const getFilterLabel = (condition) => {
  const {
    operatorLabel,
    value,
    type,
    operator,
    customFieldName,
    frequency,
    campaignType,
    campaignId,
  } = condition;
  const filterOption = getFilterOption(type);
  const filterLabel = filterOption ? filterOption.label : type;

  // Get the proper operator label from filter options
  const operatorConfig = filterOption?.operators?.find(
    (op) => op.key === operator,
  );
  const displayOperatorLabel =
    operatorConfig?.label || operatorLabel || operator;

  // Check if this is a message filter with frequency
  if (
    (type === "receivedMessageAt" ||
      type === "placedOrderAt" ||
      type === "openedMessageAt" ||
      type === "clickedUrlAt" ||
      type === "clickedButtonAt") &&
    frequency
  ) {
    const frequencyLabel =
      frequency === "atLeastOnce" ? "at least once" : "zero times";
    const dayText = parseInt(value) === 1 ? "day" : "days";
    const isRelativeDate = operatorConfig?.isRelative;

    // Add campaign information if specified
    let campaignInfo = "";
    if (campaignType && campaignType !== "any" && campaignId) {
      // Use "in" for Clicked URL and Clicked button, "from" for others
      const preposition =
        type === "clickedUrlAt" || type === "clickedButtonAt" ? "in" : "from";
      campaignInfo = ` ${preposition} ${campaignType} ${campaignId}`;
    }

    return `${filterLabel} ${frequencyLabel} ${displayOperatorLabel} ${value}${isRelativeDate ? ` ${dayText} ago` : ""}${campaignInfo}`;
  }

  // Check if this is a relative date operator (more than/less than with days)
  const isRelativeDate =
    (type === "createdAt" ||
      type === "optinAt" ||
      type === "optoutAt" ||
      type === "birthday" ||
      type === "receivedMessageAt" ||
      type === "placedOrderAt" ||
      type === "openedMessageAt") &&
    operatorConfig?.isRelative;

  if (isRelativeDate) {
    const dayText = parseInt(value) === 1 ? "day" : "days";
    return `${filterLabel} ${displayOperatorLabel} ${value} ${dayText} ago`;
  }

  // Handle custom field labels
  if (type === "customField" && customFieldName) {
    return `${customFieldName} ${displayOperatorLabel} ${value}`;
  }

  return `${filterLabel} ${displayOperatorLabel} ${value}`;
};
